<title>{{ ndcRegistrationManualPage.htmlTitle }}</title>
<app-banner [banner]="ndcRegistrationManualPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<app-ndc-registration-manual-card [cardSectionsMap]="ndcRegistrationManualPage.cardSectionsMap"></app-ndc-registration-manual-card>
